import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Checkbox, notification } from "antd";
import { consignorService } from "../../../../services/consignor.services";
import i18n from "../../../../i18n";

export default function PremiumAccessPage() {
  const [consignors, setConsignors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentConsignor, setCurrentConsignor] = useState(null);
  const [accessMap, setAccessMap] = useState({});
  const [labels, setLabels] = useState({});

  useEffect(() => {
    consignorService
      .getConsignorsList()
      .then((list) => {
        setConsignors(list);
      })
      .catch((err) => {
        notification.error({
          message: "Ошибка загрузки списка",
          description: err,
        });
      })
      .finally(() => setLoading(false));
  }, []);

  const handleOpenModal = (consignor) => {
    setCurrentConsignor(consignor);
    consignorService
      .getPremiumAccessList(consignor.Id)
      .then((data) => {
        const payload = (data && data.data) ? data.data : data;
        let access = (payload && payload.list) ? payload.list : {};
        let ruLabels = (payload && payload.labels) ? payload.labels : {};
        if (!Object.keys(access).length && payload && typeof payload === 'object') {
          if (payload.list && payload.labels) {
            access = payload.list;
            ruLabels = payload.labels;
          }
        }
        setAccessMap(access || {});
        setLabels(ruLabels || {});
        setModalVisible(true);
      })
      .catch((err) => {
        notification.error({
          message: "Ошибка загрузки доступа",
          description: err,
        });
      });
  };

  const handleToggle = (key) => {
    setAccessMap({
      ...accessMap,
      [key]: !accessMap[key],
    });
  };

  const handleSave = () => {
    consignorService
      .editPremiumAccess(currentConsignor.Id, accessMap)
      .then((resp) => {
        notification.success({
          message: i18n.t("components.notification.titles.save"),
          description: resp.message,
        });
        setModalVisible(false);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t("components.notification.titles.save"),
          description: err,
        });
      });
  };

  const columns = [
    { title: "ID", dataIndex: "Id", key: "Id" },
    { title: "Название", dataIndex: "Name", key: "Name" },
    {
      title: "",
      key: "action",
      render: (text, record) => (
        <Button className="typical-btn-blue" onClick={() => handleOpenModal(record)}>
          Изменить
        </Button>
      ),
    },
  ];

  const accessKeys = Object.keys(accessMap || {}).sort();

  return (
    <div>
      <Table rowKey="Id" loading={loading} columns={columns} dataSource={consignors} pagination={false} />
      <Modal
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleSave}
        okText="Сохранить"
        cancelText={i18n.t("main.buttons.close")}
        title="Настройки ГВ"
      >
        {accessKeys.length === 0 ? (
          <div>Нет данных доступа</div>
        ) : (
          accessKeys.map((key) => (
            <div key={key} style={{ marginBottom: 8 }}>
              <Checkbox checked={!!accessMap[key]} onChange={() => handleToggle(key)}>
                {labels[key] || key}
              </Checkbox>
            </div>
          ))
        )}
      </Modal>
    </div>
  );
}
